document.addEventListener('DOMContentLoaded', function() {
  const AMAZON_LINKS_SELECTOR = '[data-variant-amazon-links]';

  function parseVariantData(scriptElement) {
    if (!scriptElement) return null;

    try {
      return JSON.parse(scriptElement.textContent);
    } catch (error) {
      console.error('Failed to parse variant Amazon links JSON:', error);
      return null;
    }
  }

  function getProductFormScope(source) {
    return source?.closest?.('.product__info, .product-form') || null;
  }

  function getProductFormElement(scope) {
    return scope?.querySelector('form[is="product-form"], form[action*="/cart/add"], form') || null;
  }

  function getVariantDataForScope(scope) {
    if (!scope) return null;

    const scopedScript = scope.querySelector(AMAZON_LINKS_SELECTOR);
    if (scopedScript) {
      return parseVariantData(scopedScript);
    }

    const section = scope.closest('.shopify-section');
    if (section) {
      return parseVariantData(section.querySelector(AMAZON_LINKS_SELECTOR));
    }

    return parseVariantData(document.querySelector(AMAZON_LINKS_SELECTOR));
  }

  function getVariantState(scope, variant) {
    const variantData = getVariantDataForScope(scope);
    if (!variantData) return null;

    const variantId = variant?.id != null
      ? String(variant.id)
      : getProductFormElement(scope)?.querySelector('input[name="id"]')?.value;

    if (!variantId) return null;

    const variantInfo = variantData[String(variantId)];
    if (!variantInfo) return null;

    return {
      variantId,
      variantInfo,
      isAvailable: variant ? Boolean(variant.available) : Boolean(variantInfo.available),
      hasAmazonLink: Boolean(variantInfo.amazon_link)
    };
  }

  function setContainerVisibility(container, shouldShow) {
    if (!container) return;

    container.classList.toggle('hidden', !shouldShow);
    container.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
    container.toggleAttribute('hidden', !shouldShow);

    if (shouldShow) {
      container.style.removeProperty('display');
    } else {
      container.style.setProperty('display', 'none', 'important');
    }
  }

  function bindBackInStockButtons(scope) {
    if (!scope) return;

    const buttons = scope.querySelectorAll('[data-bis-open-button]');

    buttons.forEach(function(button) {
      if (button.dataset.bisBound === 'true') return;

      button.dataset.bisBound = 'true';
      button.addEventListener('click', function(event) {
        event.preventDefault();

        const proxyTrigger = button
          .closest('[data-product-cta="bis"]')
          ?.querySelector('.klaviyo-bis-trigger');

        proxyTrigger?.click();
      });
    });
  }

  function updateAvailabilityCtas(scope, variant) {
    if (!scope) return;

    const variantState = getVariantState(scope, variant);
    if (!variantState) return;

    const shouldShowAmazon = variantState.hasAmazonLink && !variantState.isAvailable;
    const shouldShowBis = !variantState.isAvailable && !shouldShowAmazon;
    const shouldShowAddToCart = !shouldShowAmazon && !shouldShowBis;
    const addToCartContainer = scope.querySelector('[data-product-cta="add-to-cart"]');
    const amazonContainer = scope.querySelector('[data-product-cta="amazon"]');
    const bisContainer = scope.querySelector('[data-product-cta="bis"]');

    setContainerVisibility(addToCartContainer, shouldShowAddToCart);
    setContainerVisibility(amazonContainer, shouldShowAmazon);
    setContainerVisibility(bisContainer, shouldShowBis);

    if (!shouldShowAmazon) return;

    const amzLink = amazonContainer?.querySelector('.amz_links');
    if (amzLink) {
      amzLink.href = variantState.variantInfo.amazon_link;
    }
  }

  function observeBackInStockTrigger(scope) {
    if (!scope) return;

    const observer = new MutationObserver(function() {
      updateAvailabilityCtas(scope);
    });

    observer.observe(scope, {
      childList: true,
      subtree: true
    });
  }

  document.addEventListener('variant:changed', function(event) {
    const variant = event.detail?.variant;
    const scope = getProductFormScope(event.target);

    if (!variant || !scope) return;

    updateAvailabilityCtas(scope, variant);
  });

  const scopes = Array.from(document.querySelectorAll('.product__info, .product-form'))
    .filter(function(scope, index, list) {
      return list.indexOf(scope) === index;
    });

  scopes.forEach(function(scope) {
    bindBackInStockButtons(scope);
    observeBackInStockTrigger(scope);
    updateAvailabilityCtas(scope);
  });
});
